import SearchIcon from '@material-ui/icons/Search'
import useDebounce from 'helpers/debounce'
import CircularProgress from '@material-ui/core/CircularProgress'
import React, { useState, useEffect } from 'react'
import { TextField } from '@material-ui/core'
import { IProps, Option } from './Interface'
import { Autocomplete, RenderOptionState } from '@material-ui/lab'
import useStyles from './Styles'

const InputTypeahead: React.FC<IProps> = ({ searchTermAction, onChange, alwaysEnabled, limit, ...props }) => {
  const { defaultValue, loading, id, disabled } = props
  const [searchTerm, setSearchTerm] = useState(null)
  const [value, setValue] = useState(defaultValue)
  const debounceSearchTerm = useDebounce(searchTerm, 500)
  const classes = useStyles({
    alwaysEnabled
  })

  useEffect(() => {
    if (debounceSearchTerm && debounceSearchTerm.length >= 3) {
      searchTermAction(debounceSearchTerm)
    }
  }, [debounceSearchTerm])

  const handleChange = (newValue: Option) => {
    setSearchTerm(null)
    setValue(newValue)
    if (onChange) {
      onChange(newValue)
    }
  }

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const valueLabel = searchTerm !== null ? searchTerm : value ? value.label : ''

  return (
    <Autocomplete
      {...props}
      blurOnSelect={true}
      className={classes.autoComplete}
      getOptionLabel={(option: Option) => option.label || ''}
      onChange={(_event: React.ChangeEvent<{}>, value: Option) => handleChange(value)}
      renderOption={(option: any, _state: RenderOptionState) => (
        <span data-testid={`${id}-option-${option.value}`}>{option.label}</span>
      )}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant="outlined"
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            className: classes.input,
            endAdornment: loading ? (
              <CircularProgress data-testid={`${id}-icon-loading`} color="inherit" size={14} />
            ) : (
              <SearchIcon data-testid={`${id}-icon-search`} className={classes.searchIcon} />
            )
          }}
          inputProps={{
            ...params.inputProps,
            maxLength: limit,
            value: valueLabel,
            onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
              setSearchTerm(event.target.value)
            },
            'data-testid': id
          }}
        />
      )}
    />
  )
}

InputTypeahead.defaultProps = {
  alwaysEnabled: true,
  disabled: false
}

export default React.memo(InputTypeahead)
